<template>
    <layout
        :showuserinfo="false"
        :title="`Cukai Tanah: ${this.noHm ?? 'Loading...'} `"
        :crumbs="crumbs"
    >
        <w-button class="mb3" text @click="kembali()">
            &#60;&#60; Kembali
        </w-button>
        <w-flex class="align-center justify-center" v-if="loading">
            <w-spinner />
        </w-flex>

        <z-page title="Butiran Hak Milik" :append-button="true" v-if="!loading">
            <hakmilik :cukai="culai" />
        </z-page>

        <!---->
        <z-page class="mt3" title="Daftar Diskaun" :append-button="true">
            <w-form @success="submit()" v-model="valid">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            placeholder="Sila Masukkan No. MMK"
                            v-model="form.no_tauliah"
                            :validators="[validators.required]"
                            >No. MMK</w-input
                        >
                    </div>

                    <div class="xs6">
                        <w-select
                            label="Pemilik"
                            placeholder="Sila Pilih Pemilik"
                            v-model="form.profil_id"
                            :items="pemiliks"
                            :validators="[validators.required]"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt3 mb5">
                    <div class="xs6 mr3">
                        <w-input
                            type="date"
                            v-model="form.tarikh_mula"
                            :validators="[validators.required]"
                            >Tarikh Mula</w-input
                        >
                    </div>
                    <div class="xs6">
                        <w-input
                            type="date"
                            v-model="form.tarikh_tamat"
                            :validators="[validators.required]"
                            >Tarikh Tamat</w-input
                        >
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-select
                            label="Kategori"
                            placeholder="Sila Pilih Kategori"
                            v-model="form.lkp_hm_ampun_hasil_id"
                            :items="kodKategori"
                            :validators="[validators.required]"
                        />
                    </div>
                    <!-- <div class="xs4">
                        <w-input placeholder="40.00" v-model="form.amaun_cukai" type="number">Amaun Cukai (RM)</w-input>
                    </div> -->
                    <!-- <div class="xs4">
                        <w-input placeholder="10" v-model="form.peratus_ampun"  type="number">Peratus (%)</w-input>
                    </div> -->
                    <div class="xs6 mr3">
                        <w-input
                            placeholder="4.00"
                            v-model="form.amaun"
                            type="number"
                            :validators="[validators.required]"
                            >Amaun Ampun (RM)</w-input
                        >
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input type="file" placeholder="Muat Naik Watikah">
                            Watikah
                        </w-input>
                    </div>
                </w-flex>
                <div class="d-flex justify-end mt3">
                    <w-button
                        class="my1 mr0"
                        type="submit"
                        :disabled="valid === false"
                        :loading="registering"
                    >
                        Daftar
                    </w-button>
                </div>
            </w-form>
        </z-page>

        <z-page class="mt3" title="Butiran Diskaun" :append-button="true">
            <Table
                :headers="ampunHasil.headers"
                :items="ampunHasil.items"
                :loading="loading"
            >
                <template
                    #item-cell.tarikh_mula="{ item, label, header, index }"
                >
                    {{ moment(item.tarikh_mula).format("DD-MM-YYYY") }}
                </template>

                <template
                    #item-cell.tarikh_tamat="{ item, label, header, index }"
                >
                    {{ moment(item.tarikh_tamat).format("DD-MM-YYYY") }}
                </template>

                <template #item-cell.action="{ item, label, header, index }">
                    <inertia-link
                        :href="$route('cukai-tanah.kemasAmpun')"
                        :data="{ no_tauliah: item.no_tauliah }"
                    >
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <w-icon v-on="on"> fal fa-pencil </w-icon>
                            </template>
                            Kemaskini
                        </w-tooltip>
                    </inertia-link>
                </template>
            </Table>
        </z-page>
        <!---->
    </layout>
</template>

<script>
import ZResource from "@/Modules/z-resource";
import Hakmilik from "../Component/Hakmilik";
import moment from "moment";
import Table from "../Component/Table";

export default {
    extends: ZResource,
    props: {
        noHm: [Object],
    },
    components: {
        Hakmilik,
        Table,
    },
    data() {
        return {
            valid: null,
            validators: {
                required: (value) => !!value || "Sila Isi Ruangan Ini",
            },
            loading: true,
            registering: false,

            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,

            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Senarai", route: "/cukai-tanah/senarai" },
            ],
            kodKategori: [{ label: "Loading", selected: true }],
            pemiliks: [{ label: "Loading", selected: true }],
            form: {
                hm_akaun_id: null,
                lkp_hm_ampun_hasil_id: null,
                keluasan: null,
                no_tauliah: null,
                tarikh_mula: null,
                tarikh_tamat: null,
                // amaun_cukai: null,
                amaun: null,
                // peratus_ampun: 0,
                status: 1,
                profil_id: null,
            },
            culai: [],
            ampunHasil: {
                headers: [
                    { label: "No. Hak Milik", key: "no_hm" },
                    { label: "No. MMK", key: "no_tauliah" },
                    { label: "Pemilik", key: "pemilik" },
                    { label: "Keluasan Hak Milik", key: "keluasan" },
                    { label: "Keluasan Maksimum", key: "keluasan_mak" },
                    { label: "Kategori", key: "kategori" },
                    // { label: "Amaun Cukai (RM)", key: "amaun_cukai" },
                    { label: "Amaun Ampun (RM)", key: "amaun" },
                    // { label: "Peratus Ampun", key: "peratus_ampun" },
                    { label: "Tempoh Mula", key: "tarikh_mula" },
                    { label: "Tempoh Tamat", key: "tarikh_tamat" },
                    { label: "Status", key: "status" },
                    { label: "Tindakan", key: "action", align: "center" },
                ],
                items: [],
            },
        };
    },
    methods: {
        async kategori() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/jenis-ampun-hasil`,
                responseType: "json",
            }).then((e) => {
                this.kodKategori = e.data.map((d) => {
                    return { label: d.id + " - " + d.keterangan, value: d.id };
                });
            });
        },

        async submit() {
            this.registering = true;
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/ampun-hasil`,
                responseType: "json",
                data: this.form,
            }).finally((e) => {
                this.fetchData2();
                this.registering = false;
                this.$waveui.notify({
                    message: "Message.",
                    timeout: 3000,
                });
            });
        },
        async getDiskaun() {
            const l = {
                kategoriCarian: "1",
                formOption: "option1",
                kod_daerah: this.noHm.substring(2, 4),
                barcode: this.noHm,
            };
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/cari`,
                responseType: "json",
                data: l,
            }).then((e) => {
                if (e.data.length > 0) {
                    this.form.keluasan = e.data[0].keluasan;
                    this.form.hm_akaun_id = e.data[0].id;
                    this.culai = e.data[0];
                    this.pemiliks = e.data[0].pemiliks
                        .map((d) => {
                            return {
                                label: d.id + " - " + d.nama,
                                value: d.id,
                            };
                        });
                        
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        async fetchData2() {
            this.loading = true;
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/ampun-hasil?no_hm=${this.noHm}`,
                params: {
                    limit: 100,
                    offset: 0,
                },
                responseType: "json",
            })
                .then((e) => {
                    const { data, limit, offset, total } = e.data;
                    this.ampunHasil.items = data;
                })
                .finally((_) => {
                    this.loading = false;
                });
        },
        kembali() {
            window.history.back();
        },
        moment(date) {
            return moment(date);
        },
    },
    watch: {},
    computed: {
        moment: () => moment,
    },
    mounted() {
        // override default setting
        this.kategori(), this.getDiskaun();
        this.fetchData2();
        this.dialog.width = 500;
    },
};
</script>
